export const uk = {
    'desktop-view': 'Десктоп',
    'mobile-view': 'Мобильные',
    'new-tab-view': 'Новая вкладка в браузере'
};
